import '../styles/globals.scss';
// TODO: check why nextjs doesn't generate tailwind css classes
import '../styles/tailwind-build/output.css';
import '../styles/build/css/_variables.css';

import type { AppProps, AppContext } from 'next/app';
import Script from 'next/script';
// import { isProduction } from '@libs/environment';
import ErrorPageComponent from '@components/shared/error-page/error-page';
import MainLayout from '@layouts/main-layout/main-layout';
import { NextIntlClientProvider } from 'next-intl';
import { set } from 'lodash';
import { fetchTranslations } from '@services/translation.service';
import { ThemeConfig, ThemeProvider } from 'flowbite-react';
import { componentsTheme } from '@styles/theme/themeConfig';
import { isProduction } from '@libs/environment';
import MyAppProduction from './_app.production';

function flattenToNested(messages: Record<string, any>) {
  return Object.entries(messages || {}).reduce((acc, [key, value]) => set(acc, key, value), {});
}

function MyApp({ Component, pageProps }: AppProps) {
  if (pageProps.error) {
    const { errorStatus, message } = pageProps.error;
    return (
      <MainLayout>
        <ErrorPageComponent errorStatus={errorStatus} prefix={message} />
      </MainLayout>
    );
  }

  return (
    <>
      {/* Exchanger Widget Scripts - Load globally to prevent crashes */}
      <Script src="/exchanger-widget/polyfills.js" type="module" strategy="beforeInteractive" />
      <Script src="/exchanger-widget/main.js" type="module" strategy="beforeInteractive" />
      <Script
        src="https://cdn.iubenda.com/iubenda.js"
        async
        strategy="afterInteractive"
      />
      
      <NextIntlClientProvider
        messages={flattenToNested(pageProps.messages)}
        locale={pageProps.locale || 'en'}
      >
        <ThemeConfig dark={false} />
        <ThemeProvider theme={componentsTheme}>
          <Component {...pageProps} />
        </ThemeProvider>
      </NextIntlClientProvider>
    </>
  );
}

MyApp.getInitialProps = async ({ Component, ctx }: AppContext) => {
  const pageProps = Component.getInitialProps ? await Component.getInitialProps(ctx) : {};
  const locale = ctx.locale || 'en';
  let messages = {};
  try {
    messages = await fetchTranslations(locale);
  } catch (e) {
    // fallback: empty messages
  }
  return { pageProps: { ...pageProps, messages, locale } };
};

export default isProduction() ? MyAppProduction : MyApp;
